import { ValueType } from 'realgrid'
export const backOrderfields = [
    {fieldName: 'ordDt', dataType: ValueType.TEXT},
    {fieldName: 'ordNo', dataType: ValueType.TEXT},
    {fieldName: 'backOrdNo', dataType: ValueType.TEXT},
    {fieldName: 'custCd', dataType: ValueType.TEXT},
    {fieldName: 'custNm', dataType: ValueType.TEXT},
    {fieldName: 'deptCd', dataType: ValueType.TEXT},
    {fieldName: 'deptNm', dataType: ValueType.TEXT},
    {fieldName: 'itemCd', dataType: ValueType.TEXT},
    {fieldName: 'itemNm', dataType: ValueType.TEXT},
    {fieldName: 'qty', dataType: ValueType.TEXT},
    {fieldName: 'remark', dataType: ValueType.TEXT},
  ]
  export const backOrderColumns = [
    {
      name: 'ordDt',
      fieldName: 'ordDt',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: '주문일자',
    },
    {
      name: 'ordNo',
      fieldName: 'ordNo',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: '원 주문번호',
    },
    {
      name: 'backOrdNo',
      fieldName: 'backOrdNo',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: 'Back Order번호',
    },
    {
      name: 'custCd',
      fieldName: 'custCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
          text: '거래처코드',
          showTooltip: false
      }
    },
    {
        name: 'custNm',
        fieldName: 'custNm',
        type: 'data',
        width: '200',
        styleName: "rg-align-left",
        header: {
            text: '거래처명',
            showTooltip: false
        }
    },
    {
      name: 'deptCd',
      fieldName: 'deptCd',
      type: 'data',
      width: '50',
      styleName: "rg-align-center",
      header: {
          text: '부과코드',
          showTooltip: false
      },
      visible: false
    },
    {
        name: 'deptNm',
        fieldName: 'deptNm',
        type: 'data',
        width: '150',
        styleName: "rg-align-left",
        header: {
            text: '부과명',
            showTooltip: false
        }
    },
    {
      name: 'itemCd',
      fieldName: 'itemCd',
      type: 'data',
      width: '150',
      styleName: "rg-align-left",
      header: { 
          text: '제품코드',
          showTooltip: false
      }
    },
    {
        name: 'itemNm',
        fieldName: 'itemNm',
        type: 'data',
        width: '150',
        styleName: "rg-align-left",
        header: {
            text: '제품명',
            showTooltip: false
        }
    },
    {
      name: 'qty',
      fieldName: 'qty',
      type: 'data',
      width: '80',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '수량',
          showTooltip: false
      }
    },
    {
      name: 'remark',
      fieldName: 'remark',
      type: 'data',
      width: '150',
      styleName: "rg-align-center",
      header: {
          text: 'REMARK',
          showTooltip: false
      }
    },
  ]